<template>
  <div id="satisfactionSurvey" element-loading-background="rgba(255, 255, 255, 0.4)">
    <el-tabs v-model="activeTab">
      <el-tab-pane label="Customer Satisfaction Survey" name="1">
        <el-collapse v-model="activeNames">
          <el-collapse-item name="1" title="Project Basic Information">
            <el-form :model="cusSatisfactionForm" ref="cusSatisfactionForm" label-width="260px">
              <el-row>
                <el-col :xs="24" :md="12">
                  <el-form-item label="Project Name:" prop="majorProjectName">
                    <el-input  v-model="cusSatisfactionForm.majorProjectName" disabled/>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item label="Project Level:" prop="majorProjectLevel">
                    <el-input  v-model="cusSatisfactionForm.majorProjectLevel" disabled/>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item label="Department:" prop="department">
                    <el-input  v-model="cusSatisfactionForm.department" disabled/>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item label="Sales Region:" prop="salesRegion">
                    <el-input  v-model="cusSatisfactionForm.salesRegion" disabled/>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item label="Project Manager:" prop="projectManager">
                    <el-input  v-model="cusSatisfactionForm.projectManager" disabled/>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item label="Customer Name:" prop="customerName" :rules="[{ required: hasRestartRole && isClosed, message: 'Please input' }]">
                    <el-input v-model="cusSatisfactionForm.customerName" :disabled="!(hasRestartRole && isClosed)" />
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item label="Customer Phone Number:" prop="customerPhoneNumber" :rules="[{ required: hasRestartRole && isClosed, message: 'Please input' }]">
                    <el-input v-model="cusSatisfactionForm.customerPhoneNumber" :disabled="!(hasRestartRole && isClosed)" />
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item 
                    label="Customer Mail:" 
                    prop="customerMail" 
                    :rules="[
                      { required: hasRestartRole && isClosed, message: 'Please input' },
                      { validator: validateEmail, trigger: 'blur' }
                    ]"
                  >
                    <el-input 
                      v-model="cusSatisfactionForm.customerMail" 
                      :disabled="!(hasRestartRole && isClosed)"
                    />
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item label="Applicant:" prop="applicant">
                    <el-input  v-model="cusSatisfactionForm.applicant" disabled/>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item label="Application Date:" prop="sendTime">
                    <el-date-picker
                      v-model="cusSatisfactionForm.sendTime"
                      value-format="yyyy-MM-dd"
                      disabled
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item label="Survey Status:" prop="surveyStatus" style="position: relative">
                    <el-input  v-model="cusSatisfactionForm.surveyStatus" disabled/>
                    <el-button
                      class="correct-btn"
                      type="primary"
                      :loading="cusCorrectLoading"
                      size="small"
                      @click="changeSurveyStatus('cusSatisfactionForm')"
                      v-has="{ class: 'corrected' }"
                      v-if="cusSatisfactionForm.surveyStatus === 'Completed'"
                    >
                      Manual Corrections
                    </el-button>
                  </el-form-item>
                  
                </el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item label="Overall Score:" prop="overallScore">
                    <el-input  v-model="cusSatisfactionForm.overallScore" disabled/>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item label="Survey Result Input Date:" prop="submittedTime">
                    <el-date-picker
                      v-model="cusSatisfactionForm.submittedTime"
                      value-format="yyyy-MM-dd"
                      disabled
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div style="text-align: center; padding: 0 0 30px 0px" v-if="hasRestartRole && isClosed">
              <el-button type="primary" v-has="{ class: 'restartSurvey' }" size="small" :loading="cusResLoading" @click="confirmRestartBefore('Customer')">Restart the satisfaction survey</el-button>
              <!-- <el-tooltip class="item" effect="dark" content="If you receive a mail indicating that the satisfaction survey failed to send, please update your mailbox address and then click to restart the satisfaction survey." placement="top-start">
                <i class="el-icon-question icon-label" style="font-size: 18px" />
              </el-tooltip> -->
            </div>
            <div style="padding-bottom: 10px; font-size: 14px;" v-if="cusSatisfactionForm.surveyStatus === 'Final Result'">
              <i class="el-icon-warning-outline" style="color: #ffa500; font-size: 18px; margin-top: 2px;"></i>
              Note：The following satisfaction survey results are the data which is from customer.
            </div>
            <el-table :data="customerData" v-if="customerData && customerData.length > 0" :span-method="arraySpanMethod" border style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
              <el-table-column prop="id" label="id" v-if="false" ></el-table-column>
              <el-table-column prop="questionText" label="Questionnaire Content" align="left" min-width="260" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="weight" label="Weight" align="center" min-width="120" :show-overflow-tooltip="true"> </el-table-column>
              <el-table-column prop="score" label="Sub-item Score" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
            <!-- <el-input style="margin: 10px 0" type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" readonly v-model="suggestionsText" v-if="suggestionsText" /> -->
          </el-collapse-item>
        </el-collapse>
      </el-tab-pane>
      <el-tab-pane label="Market Satisfaction Survey" name="2" v-if="companyOrRepresentative && companyOrRepresentative === '1' ">
        <el-collapse v-model="activeNames">
          <el-collapse-item name="1" title="Project Basic Information">
            <el-form :model="marSatisfactionForm" ref="marSatisfactionForm" label-width="260px">
              <el-row>
                <el-col :xs="24" :md="12">
                  <el-form-item label="Project Name:" prop="majorProjectName">
                    <el-input  v-model="marSatisfactionForm.majorProjectName" disabled/>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item label="Project Level:" prop="majorProjectLevel">
                    <el-input  v-model="marSatisfactionForm.majorProjectLevel" disabled/>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item label="Department:" prop="department">
                    <el-input  v-model="marSatisfactionForm.department" disabled/>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item label="Sales Region:" prop="salesRegion">
                    <el-input  v-model="marSatisfactionForm.salesRegion" disabled/>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item label="Project Manager:" prop="projectManager">
                    <el-input  v-model="marSatisfactionForm.projectManager" disabled/>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item label="Market Contact Person Name:" prop="marketPersonnelNo" :rules="[{ required: false, message: 'Please input' }]">
                    <el-select
                      v-model="marSatisfactionForm.marketPersonnelNo"
                      clearable
                      filterable
                      remote
                      placeholder="Please input"
                      :remote-method="value => remoteMethod('marketUserList', value)"
                      @change="changeMarketUser"
                      :disabled="!(hasRestartRole && isClosed)"
                    >
                      <el-option v-for="(item, index) in marketUserList" :key="index" :label="item.empName + ' ' + item.empCode" :value="item.empCode"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item label="Applicant:" prop="applicant">
                    <el-input  v-model="marSatisfactionForm.applicant" disabled/>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item 
                    label="Market Contact Person Mail:" 
                    prop="marketContactPersonMail" 
                    :rules="[
                      { required: hasRestartRole && isClosed, message: 'Please input' },
                      { validator: validateEmail, trigger: 'blur' }
                    ]"
                  >
                    <el-input 
                      v-model="marSatisfactionForm.marketContactPersonMail" 
                      :disabled="!(hasRestartRole && isClosed)"
                    />
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item label="Survey Status:" prop="surveyStatus" style="position: relative">
                    <el-input  v-model="marSatisfactionForm.surveyStatus" disabled/>
                    <el-button
                      class="correct-btn"
                      type="primary"
                      :loading="marCorrectLoading"
                      size="small"
                      @click="changeSurveyStatus('marSatisfactionForm')"
                      v-has="{ class: 'corrected' }"
                      v-if="marSatisfactionForm.surveyStatus === 'Completed'"
                    >
                      Manual Corrections
                    </el-button>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item label="Application Date:" prop="sendTime">
                    <el-date-picker
                      v-model="marSatisfactionForm.sendTime"
                      value-format="yyyy-MM-dd"
                      disabled
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item label="Survey Result Input Date:" prop="submittedTime">
                    <el-date-picker
                      v-model="marSatisfactionForm.submittedTime"
                      value-format="yyyy-MM-dd"
                      disabled
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item label="Satisfaction level:" prop="satisfactionLevel">
                    <el-input  v-model="marSatisfactionForm.satisfactionLevel" disabled/>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div style="text-align: center; padding: 0 0 30px 0px" v-if="hasRestartRole && isClosed">
              <el-button type="primary" v-has="{ class: 'restartSurvey' }" size="small" :loading="marResLoading" @click="confirmRestartBefore('Market')">Restart the satisfaction survey</el-button>
              <!-- <el-tooltip class="item" effect="dark" content="If you receive a mail indicating that the satisfaction survey failed to send, please update your mailbox address and then click to restart the satisfaction survey." placement="top-start">
                <i class="el-icon-question icon-label" style="font-size: 18px" />
              </el-tooltip> -->
            </div>
            <div style="padding-bottom: 10px; font-size: 14px;" v-if="marSatisfactionForm.surveyStatus === 'Final Result'">
              <i class="el-icon-warning-outline" style="color: #ffa500; font-size: 18px; margin-top: 2px;"></i>
              Note：The following satisfaction survey results are the data which is from market.
            </div>
            <el-table :data="marketData" v-if="marketData && marketData.length > 0" border style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
              <el-table-column prop="id" label="id" v-if="false" ></el-table-column>
              <el-table-column prop="questionText" label="Questionnaire Content" align="left" min-width="260" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="answerText" label="Satisfaction level" align="center" min-width="260" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
          </el-collapse-item>
        </el-collapse>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
  import moment from 'moment';
  export default {
    name: 'satisfactionSurvey',
		props: {
			id: {
        type: Number,
        default: null,
      },
			companyOrRepresentative: {
				type: String,
        default: '',
			},
      isClosed: {
				type: Boolean,
        default: false,
			}
		},
    created () {
      this.getSurvey();
      this.hasRestartRole = this.$_has('restartSurvey')
    },
		watch: {
		},
    data () {
      return {
        moment,
        activeTab: '1',
        customerData: [],
        // customerRestartShow: false,
        cusResLoading: false,
        marketData: [],
        // marketRestartShow: false,
        marResLoading: false,
        activeNames: ['1'],
        cusSatisfactionForm: {},
        marSatisfactionForm: {},
        marketUserList: [],
        cusCorrectLoading: false,
        marCorrectLoading: false,
        suggestionsText: '',
        hasRestartRole: false,
      }
    },
    methods: {
      arraySpanMethod({ row, column, rowIndex, columnIndex }) {
        // 判断是否需要合并（questionType为textarea时合并）
        if (row.questionType === 'short_answer') {
          if (columnIndex === 0) {
            return [1, 1]; // 第一列正常显示
          } else if (columnIndex === 1) {
            return {
              rowspan: 1,
              colspan: 2,
              style: { textAlign: 'center' }
            };
          } else if (columnIndex === 2) {
            return [0, 0]; // 隐藏第三列
          }
        }
        // 不需要合并的行保持默认
        return [1, 1];
      },
      validateEmail(rule, value, callback) {
        const rule1 = /^([a-zA-Z0-9]+[_|\_|\.|\-]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.|\-]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,14}$/;
        const rule2 = /^[a-zA-Z0-9._@-]+$/;
        if (!value) {
          // 如果非必填且值为空，直接通过（如果需要必填，由 required 规则处理）
          callback();
          return;
        }
        // 检查是否符合 rule1 和 rule2
        if (!rule1.test(value) || !rule2.test(value)) {
          callback(new Error('Invalid mail'));
        } else {
          callback(); // 验证通过
        }
      },
			remoteMethod(list, query) {
				if (query !== '') {
					// 清除之前的定时器
					if (this.timeout) {
						clearTimeout(this.timeout)
					}
					// 防抖处理，300ms后执行
					this.timeout = setTimeout(() => {
						this.fetchUserOptions(list, query)
					}, 200)
				} else {
					this[list] = []
				}
			},
			fetchUserOptions(list, query) {
				let url =`${this.$store.state.islhurl}user/select-option?keyword=${query}`;
				this._get(url).then().then(res => {
					if(res.code === 200 && res.data) {
						this[list] = res.data;
					} else {
						this[list] = [];
					}
				}).catch(error => {
					this[list] = [];
					console.error('搜索失败:', error)
				})
			},
      changeMarketUser(value) {
        if(value.trim() === '') {
          this.marSatisfactionForm.marketPersonnelName = '';
        } else {
          const selectedOption = this.marketUserList.find(option => option.empCode === value);
          this.marSatisfactionForm.marketPersonnelName = selectedOption.empName;
        }
      },
      getSurvey() {
				let url = `${this.$store.state.islhurl}major-project-survey/admin-survey?majorProjectId=${this.id}`;
        console.log(url)
				const _this = this
				this._get(url).then(
					res => {
            if (res.data && res.code === 200) {
              const data = res.data;
              this.cusSatisfactionForm =  {
                ...this.cusSatisfactionForm,
                ...data,
                ...data.customer,
              }
              this.marSatisfactionForm =  {
                ...this.marSatisfactionForm,
                ...data,
                ...data.market,
              }
              let customerData =  data.customer? data.customer.questions : []
              this.customerData = customerData.map(item => ({
                ...item,
                weight: item.questionType === 'short_answer' ? (item.answers? item.answers.answerText : '') : (item.weight !== null ? Number(item.weight * 100).toFixed(0) + '%' : ''),
                score: item.answers? item.answers.score : '',
                answerText: item.answers? item.answers.answerText : '',
              }));
              let marketData =  data.market? data.market.questions : []
              this.marketData = marketData.map(item => ({
                ...item,
                answerText: item.answers? item.answers.answerText : '',
                score: item.answers? item.answers.score : '',
              }));
              // this.suggestionsText = customerData.length > 0 ?
              //   customerData[customerData.length - 1].answers ?
              //     customerData[customerData.length - 1].answers.answerText :
              //     ''
              //   :
              // '';
              // this.customerRestartShow = data.customer? data.customer.sendStatus === 'Failed' : false;
              // this.marketRestartShow = data.market? data.market.sendStatus === 'Failed' : false;
              if(this.marSatisfactionForm.marketPersonnelNo) {
                this.remoteMethod('marketUserList', this.marSatisfactionForm.marketPersonnelNo)
              }
            }
					}
				)
			},
      confirmRestartBefore(surveyType) {
        let params = {
          majorProjectId: this.id,
          surveyType,
        }
        if (surveyType === 'Market') {
          this.$refs.marSatisfactionForm.validate((valid) => {
            if (valid) {
              params.marketPersonnelName = this.marSatisfactionForm.marketPersonnelName
              params.marketPersonnelNo = this.marSatisfactionForm.marketPersonnelNo
              params.marketContactPersonMail = this.marSatisfactionForm.marketContactPersonMail
              this.confirmRestart(params)}
          });
        } else {
          this.$refs.cusSatisfactionForm.validate((valid) => {
            if (valid) {
              params.customerName = this.cusSatisfactionForm.customerName
              params.customerPhoneNumber = this.cusSatisfactionForm.customerPhoneNumber
              params.customerMail = this.cusSatisfactionForm.customerMail
              this.confirmRestart(params)
            }
          });
        }
      },
      confirmRestart(params) {
        this.$confirm("Are you sure to Restart the satisfaction survey?", "Warning", {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          if (params.surveyType === 'Customer') {
            this.cusResLoading = true
          } else {
            this.marResLoading = true
          }
          let url = `${this.$store.state.islhurl}major-project-survey/resend-survey`
          this._post(url, params).then(
            res => {
              if (params.surveyType === 'Customer') {
                this.cusResLoading = false
              } else {
                this.marResLoading = false
              }
              if (res.code === 200) {
                this.$Message.success('Restart Successful!' )
                this.getSurvey()
              } else {
                this.$message.error('Restart Failed!');
              }
            }
          )
          .catch(() => {
            if (params.surveyType === 'Customer') {
              this.cusResLoading = false
            } else {
              this.marResLoading = false
            }
          });
        }).catch(() => {
        });
      },
      changeSurveyStatus(form) {
        this.$confirm("Are you sure to Manual Corrections the status?", "Warning", {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          let url = `${this.$store.state.islhurl}major-project-survey/corrected`
          const params = new URLSearchParams();
          params.append('surveyId', this[form].id);
          if ( form === 'cusSatisfactionForm' ) {
            this.cusCorrectLoading = true
          } else {
            this.marCorrectLoading = true
          }
          this._post(url, params).then(
            res =>{
              if ( form === 'cusSatisfactionForm' ) {
                this.cusCorrectLoading = false
              } else {
                this.marCorrectLoading = false
              }
              if (res.code === 200) {
                this.$Message.success('Manual Corrections Successful!' )
                this.getSurvey()
              } else {
                this.$message.error(res.message || 'Manual Corrections Failed!');
              }
            }
          )
          .catch(() => {
            if ( form === 'cusSatisfactionForm' ) {
              this.cusCorrectLoading = false
            } else {
              this.marCorrectLoading = false
            }
          });
        }).catch(() => {
        });
      },
    },
  }
</script>
<style lang="less" scoped>
#satisfactionSurvey {
	.el-form {
		padding: 20px 0;
		/deep/.el-input {
			max-width: 350px;
		}
		/deep/.el-form-item__label {
			line-height: 22px;
			padding: 9px 12px 9px 12px;
		}
		/deep/.el-input-number {
			width: 100%;
			.el-input__inner {
				text-align: left;
			}
		}
    /deep/.el-upload-list__item.is-success.focusing .el-icon-close-tip {
			display: none !important;
		}
		/deep/.el-select {
			width: 100%;
			.el-select__tags {
				max-width: 100%!important;
			}
		}
		/deep/.el-form-item__content .el-input__suffix {
			left: auto;
			right: 10px;
		}
		/deep/.el-range-editor.el-input__inner {
			width: 100%;
			max-width: 350px;
		}
    /deep/.el-textarea {
      max-width: 350px;
    }
    /deep/.el-range-editor.is-disabled input {
      color: #606266;
    }
    /deep/.el-textarea.is-disabled .el-textarea__inner {
      color: #606266;
    }
    /deep/.el-date-editor .el-range-input {
      font-size: 12px;
    }
    /deep/.el-date-editor .el-range__icon {
      line-height: 24px;
    }
	}
  .correct-btn {
    position: absolute;
    margin-left: 10px;
    margin-top: 5px;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/major/satisfactionSurvey/index.vue